export default "__VITE_ASSET__dc6feb80__"